import { css } from "@emotion/react";
import { useState } from "react";
import { GridListSection } from "react-aria-components";
import { useNavigate } from "react-router";

import {
  Button,
  Counter,
  DialogTrigger,
  GridList,
  GridListItem,
  GridListSectionTitle,
  Icon,
  Icons,
  MenuContainer,
  Separator,
  Text,
} from "@phoenix/components";
import { usePlaygroundContext } from "@phoenix/contexts/PlaygroundContext";

export function PlaygroundGeneralEvaluatorSelect() {
  const navigate = useNavigate();
  const [evaluatorMenuOpen, setEvaluatorMenuOpen] = useState(false);

  const { selectedEvaluators, setSelectedEvaluators } = usePlaygroundContext(
    (state) => ({
      selectedEvaluators: state.selectedEvaluators ?? [],
      setSelectedEvaluators: state.setSelectedEvaluators,
    })
  );

  const evaluators = [
    { id: "correctness", name: "Correctness", description: "General correctness" },
    { id: "relevance", name: "Relevance", description: "Answer relevance" },
    { id: "toxicity", name: "Toxicity", description: "Toxic content detection" },
    { id: "instruction_following", name: "Instruction Following", description: "Instruction following quality" },
    { id: "reasoning_quality", name: "Reasoning Quality", description: "Reasoning quality" },
    { id: "constraint_adherence", name: "Constraint Adherence", description: "Constraint adherence quality" },
  ];

  return (
    <DialogTrigger
      isOpen={evaluatorMenuOpen}
      onOpenChange={setEvaluatorMenuOpen}
    >
      <Button
        size="S"
        leadingVisual={<Icon svg={<Icons.Scale />} />}
      >
        Evaluators{" "}
        {selectedEvaluators.length > 0 && (
          <Counter>{selectedEvaluators.length}</Counter>
        )}
      </Button>
      <MenuContainer placement="bottom end" shouldFlip={true} minHeight="0">
        <GridList
          selectionMode="multiple"
          selectedKeys={selectedEvaluators}
          onSelectionChange={(keys) => {
            if (keys === "all") {
              return;
            }
            setSelectedEvaluators(Array.from(keys) as string[]);
          }}
          css={css`
            max-width: 600px;
          `}
          aria-label="Select evaluators"
        >
          <GridListSection>
            <GridListSectionTitle title="Select Evaluators" />
            {evaluators.map((evaluator) => (
              <GridListItem
                key={evaluator.id}
                id={evaluator.id}
                textValue={evaluator.name}
              >
                <Text color="gray-700">{evaluator.name}</Text>
              </GridListItem>
            ))}
          </GridListSection>
        </GridList>
        <Separator />
        <Button
          variant="quiet"
          size="S"
          leadingVisual={<Icon svg={<Icons.PlusCircleOutline />} />}
          onPress={() => {
            setEvaluatorMenuOpen(false);
            navigate("/evaluators");
          }}
          css={css`
            margin: var(--global-menu-item-gap);
            justify-content: flex-start;
          `}
        >
          Manage Evaluators
        </Button>
      </MenuContainer>
    </DialogTrigger>
  );
}
